import PropTypes from 'prop-types'

const theme = PropTypes.shape({
  space: PropTypes.arrayOf(PropTypes.number),
  inputHeights: PropTypes.arrayOf(PropTypes.number),
  fontSizes: PropTypes.arrayOf(PropTypes.number),
  fontWeights: PropTypes.objectOf(PropTypes.number),
  colors: PropTypes.objectOf(PropTypes.string),
  redius: PropTypes.string,
})

const numberStringOrArray = PropTypes.oneOfType([
  PropTypes.number,
  PropTypes.string,
  PropTypes.array,
])

const spacings = {
  // Margin
  m: numberStringOrArray,
  mt: numberStringOrArray,
  mr: numberStringOrArray,
  mb: numberStringOrArray,
  ml: numberStringOrArray,
  mx: numberStringOrArray,
  my: numberStringOrArray,

  // Padding
  p: numberStringOrArray,
  pt: numberStringOrArray,
  pr: numberStringOrArray,
  pb: numberStringOrArray,
  pl: numberStringOrArray,
  px: numberStringOrArray,
  py: numberStringOrArray,
}

export default {
  theme,
  spacings,
}
